import { ComponentClass } from 'react';

import { EngineProps } from '../renderer/react-renderer';

import ClassBridge from './class-bridge/builder';

function isClassComponent(componentClass: ComponentClass): boolean {
  const isFunction = typeof componentClass === 'function';
  return (isFunction && !!componentClass.prototype.isReactComponent) ? true : false;
}

function ReactEngineBridge(componentClass: ComponentClass): ComponentClass<EngineProps> {
  if (isClassComponent(componentClass)) {
    return ClassBridge(componentClass);
  }

  throw new Error(`[ReactEngineBridge]: unsupported non ClassComponent.`);
}

export default ReactEngineBridge;
